define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CPCustomerProfileDomainModel = /** @class */ (function () {
        function CPCustomerProfileDomainModel(data) {
            this.Domain = ko.observable();
            this.Alias = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CPCustomerProfileDomainModel.Mapping, self);
            }
        }
        CPCustomerProfileDomainModel.Mapping = {
            key: function (data) {
                return data.Domain;
            },
            create: function (options) {
                return new CPCustomerProfileDomainModel(options.data);
            }
        };
        return CPCustomerProfileDomainModel;
    }());
    return CPCustomerProfileDomainModel;
});
//# sourceMappingURL=CPCustomerProfileDomainModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CPCustomerProfileDomainModel.js
// module id = 176
// module chunks = 2